import React, { Suspense } from 'react';

import { getEnvelopeSegmentFromEnvelope } from '@paragon/layout';

import fontPath from '../../../../resources/roboto-regular.fnt';
import sdfPath from '../../../../resources/roboto-regular.png';
import { useAppSelector } from '../../../components/hooks';
import { getCommittedComponentDesignsByGuid } from '../../../store/selectors/getComponentDesignsSelectors';
import { getVisibleDesignedEnvelopes } from '../../../store/selectors/layoutDataSelectors';
import { is3DLayoutCameraInUse } from '../../../store/selectors/layoutModeSelectors';
import { getActiveEnvelopeMode } from '../../../store/selectors/layoutVisualOptionsSelectors';
import { isLabelTooTallForViewport, useAntiZoomCheck } from '../../antiZoom';
import { SDFTextProvider } from '../../text/SDFTextProvider';
import { LayoutTrussLabel } from '../truss-envelopes/LayoutTrussLabel';

const FONT_CONFIGURATION = { sdfPath, fontPath };

export function LayoutComponentLabelsController() {
  const is3D = useAppSelector(is3DLayoutCameraInUse);
  const envelopeMode = useAppSelector(getActiveEnvelopeMode);

  const trussEnvelopes = useAppSelector(getVisibleDesignedEnvelopes);
  const componentDesignsByGuid = useAppSelector(getCommittedComponentDesignsByGuid);

  const hiddenByLevelOfDetail = useAntiZoomCheck((level) => level > 15);
  // 8.5 is approximately the height of a label in world units:
  //   94px                                * 0.01                           * 9
  //   line height from roboto-regular.fnt * scale from SDFTextProvider.tsx * LABEL_SCALE from LayoutTrussLabel.tsx
  const hiddenByLabelHeight = useAntiZoomCheck((level) => isLabelTooTallForViewport(8.5, level));

  if (is3D || envelopeMode !== 'components') return null;

  return (
    <Suspense>
      <SDFTextProvider
        depthTest={false}
        fontPathRegular={FONT_CONFIGURATION}
        visible={!hiddenByLevelOfDetail && !hiddenByLabelHeight}
      >
        {trussEnvelopes.map((envelope) => {
          const componentDesign =
            envelope.componentDesignGuid == null ? undefined : componentDesignsByGuid[envelope.componentDesignGuid];
          if (!componentDesign) return null;

          const envelopeCenterSegment = getEnvelopeSegmentFromEnvelope(envelope, 'Center');
          if (envelopeCenterSegment == null) return null;

          return (
            <LayoutTrussLabel
              key={envelope.guid}
              envelopeGuid={envelope.guid}
              envelopeCenterSegment={envelopeCenterSegment}
              elevation={envelope.elevation}
              componentName={componentDesign.component.name}
              labelPlacement={envelope.labelPlacement}
            />
          );
        })}
      </SDFTextProvider>
    </Suspense>
  );
}
